import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import Cookies from "js-cookie";
import Lenis from "lenis";
import PhotoSwipe from "photoswipe";
import PhotoSwipeLightbox from "photoswipe/lightbox";
import Swiper from "swiper";
import { Navigation, Scrollbar } from "swiper/modules";

import "photoswipe/style.css";
import "swiper/css";
import "swiper/css/scrollbar";

import "./components/header-banner";

gsap.registerPlugin(ScrollTrigger);

const lenis = new Lenis({
  duration: 1.45,
  direction: "vertical",
  gestureDirection: "vertical",
  smooth: true,
  mouseMultiplier: 1,
  smoothTouch: false,
  touchMultiplier: 2,
  infinite: false,
});

const popupProductIdsField = document.querySelector(
  ".popup input[name=yl-productIds]",
);
const popupProjectsIdsField = document.querySelector(
  ".popup input[name=yl-projectIds]",
);
const popupMessageField = document.querySelector(
  ".popup textarea[name=yl-message]",
);

function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}

requestAnimationFrame(raf);

let swiperDeveloper = null;
let advantagesTimeline;

function initializeSwiper() {
  if (window.innerWidth <= 992 && !swiperDeveloper) {
    swiperDeveloper = new Swiper(".section-developer__elements", {
      modules: [Scrollbar],
      slidesPerView: "auto",
      spaceBetween: 10,
      centeredSlides: true,
      scrollbar: {
        el: ".section-developer .swiper-scrollbar",
        hide: false,
      },
    });

    swiperDeveloper.update();
  } else if (window.innerWidth > 992 && swiperDeveloper) {
    swiperDeveloper.destroy(true, true);
    swiperDeveloper = null;
  }
}

document.addEventListener("DOMContentLoaded", function () {
  initializeSwiper();
});

window.addEventListener("resize", () => {
  initializeSwiper();
});

document.addEventListener("DOMContentLoaded", function () {
  new Swiper(".section-slider__elements", {
    modules: [Navigation, Scrollbar],
    slidesPerView: "auto",
    spaceBetween: 10,
    navigation: {
      nextEl: ".section-slider .swiper-button-next",
      prevEl: ".section-slider .swiper-button-prev",
    },
    scrollbar: {
      el: ".section-slider .swiper-scrollbar",
      hide: false,
    },
  });
});

window.addEventListener("load", function () {
  setTimeout(function () {
    document.body.classList.add("loaded");
  }, 250);

  setTimeout(() => {
    document.body.classList.add("start");

    const sectionId = window.location.hash.slice(1);
    const targetSection = sectionId ? document.getElementById(sectionId) : null;

    if (targetSection) {
      const vw = Math.max(
        document.documentElement.clientWidth || 0,
        window.innerWidth || 0,
      );
      const offset = vw <= 992 ? -66 : -94;

      requestAnimationFrame(() => {
        ScrollTrigger.refresh();
        requestAnimationFrame(() => {
          lenis.resize();
          lenis.scrollTo(targetSection, {
            immediate: true,
            force: true,
            offset: offset,
          });
        });
      });
    }
  }, 500);
});

document.addEventListener("DOMContentLoaded", function () {
  const main = document.querySelector(".section-main");
  let mainTimeline;

  if (main) {
    // header chowa się dopiero po zakończeniu animacji pierwszej sekcji
    // i tylko podczas scrollowania w dół – po zatrzymaniu scrolla
    // lub przy scrollu w górę wraca
    const SCROLL_IDLE_DELAY = 150;
    let mainAnimationEnded = false;
    let isScrollingDown = false;
    let lastScrollY = window.scrollY;
    let scrollIdleTimer = null;

    function updateHeaderVisibility() {
      document.body.classList.toggle(
        "hide-header",
        mainAnimationEnded && isScrollingDown,
      );

      document.body.classList.toggle("is-scrolled", mainAnimationEnded);
    }

    window.addEventListener(
      "scroll",
      () => {
        const currentScrollY = window.scrollY;

        if (currentScrollY === lastScrollY) {
          return;
        }

        isScrollingDown = currentScrollY > lastScrollY;
        lastScrollY = currentScrollY;
        updateHeaderVisibility();

        clearTimeout(scrollIdleTimer);
        scrollIdleTimer = setTimeout(() => {
          isScrollingDown = false;
          updateHeaderVisibility();
        }, SCROLL_IDLE_DELAY);
      },
      { passive: true },
    );

    // Funkcja, która ustawia wartości rozmiarów w zależności od szerokości/height ekranu

    function setPathInnerSize() {
      let width, height;

      // Ustalamy wartości w zależności od rozmiaru okna
      if (window.matchMedia("(max-width: 640px)").matches) {
        width = "260px";
        height = "260px";
      } else if (window.matchMedia("(max-height: 780px)").matches) {
        width = "420px";
        height = "420px";
      } else if (window.matchMedia("(max-width: 1024px)").matches) {
        width = "560px";
        height = "560px";
      } else {
        // Domyślne wartości
        width = "560px";
        height = "560px";
      }

      return { width, height };
    }

    function initAnimation() {
      let { width, height } = setPathInnerSize();

      mainTimeline = gsap.timeline({
        scrollTrigger: {
          trigger: main,
          start: "top top",
          end: "bottom top",
          scrub: true,
          pin: true,
          pinSpacing: true,
          onUpdate: (self) => {
            mainAnimationEnded = self.progress === 1;
            updateHeaderVisibility();
          },
        },
      });

      mainTimeline
        .to(".path__inner", {
          width: width,
          height: height,
          duration: 1.2,
          ease: "none",
        })
        .to(
          ".flatta",
          {
            top: "100%",
            duration: 1,
            ease: "none",
          },
          0,
        )
        .to(
          ".section-main .section-main__text",
          {
            opacity: 1,
            duration: 0.5,
            ease: "none",
          },
          0,
        );
    }

    initAnimation();
  }

  const architect = document.querySelector(".section-architect__full-height");
  let architectTimeline;

  let scrollTriggerConfig = {
    trigger: architect,
    start: "top top",
    end: "bottom top",
    scrub: true,
    pin: true,
    pinSpacing: true,
    //markers: true,
  };

  // Użycie matchMedia do zmiany tylko start i end dla mniejszych rozdzielczości
  gsap.matchMedia().add("(max-width: 768px)", () => {
    scrollTriggerConfig.start = "top center"; // Zmiana wartości dla mniejszych ekranów
    scrollTriggerConfig.end = "bottom center";
    scrollTriggerConfig.pin = false;
  });

  if (architect) {
    const checkLocked = setInterval(() => {
      if (!document.documentElement.classList.contains("locked")) {
        // Inicjuj animację po usunięciu "locked"
        clearInterval(checkLocked);
        // Animacja dla szerokości ekranu 992px i więcej
        architectTimeline = gsap.timeline({
          scrollTrigger: scrollTriggerConfig,
        });

        architectTimeline.to(".section-architect__full-height img", {
          width: "100%",
          height: "100%", // Wysokość tylko dla dużych ekranów
          duration: 1,
          ease: "none",
        });
      }
    }, 100);
  }

  const advantages = document.querySelector(".section-advantages");

  if (advantages) {
    const checkLocked = setInterval(() => {
      if (!document.documentElement.classList.contains("locked")) {
        // Inicjuj animację po usunięciu "locked"
        clearInterval(checkLocked);
        advantagesTimeline = gsap.timeline({
          scrollTrigger: {
            trigger: advantages,
            start: "top top",
            end: "bottom bottom",
            scrub: true,
            pin: ".section-advantages__thumbnails",
            pinSpacing: true,
          },
        });
      }
    }, 100);
  }

  const sectionNumbers = document.querySelector(".numbers");

  if (sectionNumbers) {
    const checkLocked = setInterval(() => {
      if (!document.documentElement.classList.contains("locked")) {
        // Inicjuj animację po usunięciu "locked"
        clearInterval(checkLocked);

        const numberTimeline0 = gsap.timeline({
          scrollTrigger: {
            trigger: sectionNumbers, // Główny kontener z sekcjami nakładającymi się
            start: "top center",
            end: "bottom center",
            scrub: true, // Płynne przewijanie
            pin: false, // Przypnij kontener podczas przewijania
            pinSpacing: false,
            //markers: true,
          },
        });

        const numbers = document.querySelectorAll(".numbers__single");

        numbers.forEach((number, index) => {
          const numberTimeline = gsap.timeline({
            scrollTrigger: {
              trigger: number,
              start: "top 75%",
              end: "bottom 50%",
              scrub: true,
              pin: false,
              pinSpacing: false,
            },
          });

          const h1 = number.querySelector(".numbers__number");
          const isWhite = h1.classList.contains("numbers__number--white");
          const targetColor = isWhite
            ? "rgba(255, 255, 255, 1)"
            : "rgba(54, 56, 63, 1)";

          numberTimeline.to(
            h1,
            {
              color: targetColor,
              duration: 1,
            },
            0,
          );

          const description = number.querySelector(".numbers__description");
          numberTimeline.to(
            description,
            {
              opacity: 1,
              duration: 1,
            },
            0,
          );
        });
      }
    }, 100); // Sprawdź co 100 ms
  }

  const elements = document.querySelectorAll(".gsap-element");

  if (elements) {
    elements.forEach((element) => {
      // Poczekaj na usunięcie klasy "locked"
      const checkLocked = setInterval(() => {
        if (!document.documentElement.classList.contains("locked")) {
          // Inicjuj animację po usunięciu "locked"
          clearInterval(checkLocked);

          const delay =
            element.getAttribute("data-delay") === "true" ? 0.05 : 0;

          gsap
            .timeline({
              scrollTrigger: {
                trigger: element,
                start: "top 80%",
                end: "bottom center",
                scrub: false,
              },
            })
            .fromTo(
              element,
              { y: 100, opacity: 0 },
              { y: 0, opacity: 1, duration: 0.7, delay: delay },
            );
        }
      }, 100); // Sprawdź co 100 ms
    });
  }

  const envelopes = document.querySelectorAll(".envelope");

  envelopes.forEach((envelope) => {
    envelope.addEventListener("click", () => {
      document.body.classList.add("is-overlay");
      lenis.stop();
    });
  });

  document.getElementById("close-form").addEventListener("click", () => {
    if (popupProductIdsField) {
      popupProductIdsField.value = "";
    }

    if (popupProjectsIdsField) {
      popupProjectsIdsField.value = 24;
    }

    if (popupMessageField) {
      popupMessageField.value = "";

      popupMessageField.closest("label").classList.remove("is-active");
    }

    document.body.classList.remove("is-overlay");
    lenis.start();
  });

  const scrollDownButton = document.getElementById("scroll-down");

  if (scrollDownButton) {
    scrollDownButton.addEventListener("click", () => {
      const section2 = document.getElementById("inwestycja");
      lenis.scrollTo(section2, { offset: 0, duration: 2.5 });
    });
  }

  const scrollDeveloper = document.getElementById("scroll-developer");

  if (scrollDeveloper) {
    document
      .getElementById("scroll-developer")
      .addEventListener("click", () => {
        const sectionDeveloper = document.getElementById("deweloper");
        lenis.scrollTo(sectionDeveloper, { offset: 0, duration: 2.1 });
      });
  }

  const thumbnails = document.querySelectorAll(
    ".section-advantages .advantages",
  ); // Wszystkie zdjęcia w thumbnails
  const section = document.querySelector(".section-advantages"); // Sekcja, w której znajdują się zdjęcia
  const targetElements = document.querySelectorAll(".target-element"); // Elementy, do których przypisujemy klasę na podstawie data-id

  // Funkcja sprawdzająca, które zdjęcie znajduje się na środku
  function updateActiveThumbnail() {
    const sectionBounds = section.getBoundingClientRect(); // Pozycja sekcji względem widoku
    const middleOfViewport = window.innerHeight / 2; // Środek widoku
    let closestThumbnail = null;
    let closestDistance = Infinity; // Zmienna do śledzenia najbliższego zdjęcia

    thumbnails.forEach((thumbnail) => {
      const thumbnailBounds = thumbnail.getBoundingClientRect(); // Pozycja zdjęcia względem widoku
      const thumbnailMiddle =
        (thumbnailBounds.top + thumbnailBounds.bottom) / 2; // Środek zdjęcia

      // Obliczanie odległości od środka ekranu
      const distance = Math.abs(thumbnailMiddle - middleOfViewport);

      // Jeśli odległość zdjęcia od środka jest mniejsza niż dotychczasowa
      if (distance < closestDistance) {
        closestThumbnail = thumbnail;
        closestDistance = distance;
      }
    });

    // Pobranie data-id najbliższego zdjęcia
    let activeDataId = null;
    if (closestThumbnail) {
      activeDataId = closestThumbnail.getAttribute("data-id");
    }

    // Usunięcie klasy "active" ze wszystkich elementów targetowych
    targetElements.forEach((target) => target.classList.remove("active"));

    // Przypisanie klasy "active" na podstawie data-id
    if (activeDataId) {
      const target = document.querySelector(
        `.target-element[data-id="${activeDataId}"]`,
      );
      if (target) {
        target.classList.add("active");
      }
    }
  }

  if (thumbnails && thumbnails.length) {
    // Nasłuchiwanie przewijania
    window.addEventListener("scroll", updateActiveThumbnail);

    // Wywołanie funkcji na początku (np. po załadowaniu strony)
    updateActiveThumbnail();
  }

  targetElements.forEach((element) => {
    element.addEventListener("click", function () {
      const id = this.getAttribute("data-id");
      const advantagesSingle = document.getElementById("advantages-" + id);

      if (advantagesSingle) {
        lenis.scrollTo(advantagesSingle, { offset: 0, duration: 1.2 });
      }
    });
  });

  const forms = document.querySelectorAll(".wpcf7-form");

  forms.forEach((form) => {
    // Pobieramy checkbox "check-all" w danym formularzu
    const checkAll = form.querySelector(".check-all");
    // Pobieramy pozostałe checkboxy w danym formularzu
    const individualCheckboxes = form.querySelectorAll(".individual-checkbox");

    if (checkAll && individualCheckboxes.length > 0) {
      // Zaznacz/odznacz wszystkie
      checkAll.addEventListener("change", function () {
        individualCheckboxes.forEach((checkbox) => {
          checkbox.checked = checkAll.checked;
        });
      });

      // Odznaczenie "Zaznacz wszystkie", jeśli któryś z pozostałych checkboxów jest odznaczony
      individualCheckboxes.forEach((checkbox) => {
        checkbox.addEventListener("change", function () {
          if (!checkbox.checked) {
            checkAll.checked = false;
          } else {
            // Sprawdzenie, czy wszystkie są zaznaczone
            const allChecked = Array.from(individualCheckboxes).every(
              (cb) => cb.checked,
            );
            checkAll.checked = allChecked;
          }
        });
      });
    }
  });

  const buttons = document.querySelectorAll(".more");

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      const span = button.previousElementSibling;
      const isHidden =
        span.style.display === "none" || span.style.display === "";
      span.style.display = isHidden ? "inline" : "none";
      button.textContent = isHidden ? "Pokaż mniej" : "Czytaj więcej";
    });
  });

  const inputs = document.querySelectorAll(
    ".wpcf7-text, .wpcf7-tel, .wpcf7-email, textarea",
  );

  inputs.forEach((input) => {
    input.addEventListener("focus", () => {
      input.dataset.placeholder = input.placeholder;
      input.placeholder = "";
    });

    input.addEventListener("blur", () => {
      input.placeholder = input.dataset.placeholder;
    });
  });

  const menuButtonOpen = document.getElementById("menu-open");
  const menuButtonClose = document.getElementById("menu-close");

  menuButtonOpen.addEventListener("click", () => {
    document.body.classList.add("is-menu-open");
  });

  menuButtonClose.addEventListener("click", () => {
    document.body.classList.remove("is-menu-open");
  });

  const menuLinks = document.querySelectorAll(".nav button");

  menuLinks.forEach((button) => {
    button.addEventListener("click", () => {
      const sectionId = button.dataset.id;
      const sectionElement = document.getElementById(sectionId);
      lenis.scrollTo(sectionElement, { offset: 0, duration: 0.5 });
      setTimeout(() => {
        document.body.classList.remove("is-menu-open");
      }, 500);
    });
  });
});

function isPhonePortrait() {
  return window.matchMedia("(max-width: 576px) and (orientation: portrait)")
    .matches;
}

const lightbox = new PhotoSwipeLightbox({
  gallery: ".lightbox a",
  bgOpacity: 1,
  imageClickAction: "close",
  closeTitle: "Zamknij",
  zoom: false,
  showHideAnimationType: "fade",
  secondaryZoomLevel: 0.75,
  maxZoomLevel: 1,
  initialZoomLevel: (zoomLevelObject) => {
    if (isPhonePortrait()) {
      return 0.5;
    } else {
      return zoomLevelObject.fit;
    }
  },
  padding: { top: 80, bottom: 80, left: 20, right: 20 },
  pswpModule: PhotoSwipe,
});

lightbox.init();

lightbox.on("beforeOpen", () => {
  lenis.stop();
  const pswp = lightbox.pswp;
});

lightbox.on("destroy", () => {
  lenis.start();
  document.body.classList.remove("white-background");
});

lightbox.on("contentInit", ({ content }) => {
  if (content.data["element"].dataset.background) {
    document.body.classList.add("white-background");
  }
});

const lightbox2 = new PhotoSwipeLightbox({
  gallery: ".section-slider",
  children: "a",
  bgOpacity: 1,
  imageClickAction: "close",
  closeTitle: "Zamknij",
  showHideAnimationType: "fade",
  //zoom: false,
  padding: { top: 80, bottom: 80, left: 20, right: 20 },
  pswpModule: PhotoSwipe,
});

lightbox2.init();

lightbox2.on("beforeOpen", () => {
  lenis.stop();
});

lightbox2.on("destroy", () => {
  lenis.start();
});

const formRows = document.querySelectorAll(".field");

if (formRows) {
  formRows.forEach((row) => {
    const input = row.querySelector("input, textarea, select");
    const label = row.querySelector("label ");

    if (input && label) {
      function toggleLabel() {
        if (input.value.trim() !== "") {
          label.classList.add("is-active");
        } else {
          label.classList.remove("is-active");
        }
      }

      input.addEventListener("input", toggleLabel);
      toggleLabel(); // Sprawdza stan na początku
    }
  });
}

// form - events
const getYouleadContactIdFromCookie = () => {
  const cookieName = "ylid";

  const cookieValue = Cookies.get(cookieName);
  if (cookieValue) {
    const match = cookieValue.match(/browserId=([a-z0-9-]+)/);
    if (match && match[1]) {
      return match[1];
    }
  }

  return null;
};

const wpcf7Forms = document.querySelectorAll(".wpcf7");

wpcf7Forms.forEach((wpcf7Form) => {
  wpcf7Form.addEventListener("wpcf7mailsent", () => {
    dataLayer = window.dataLayer || [];

    const ylid = getYouleadContactIdFromCookie();

    const gaEvent = {
      event: "form_sent",
    };

    if (ylid) {
      gaEvent.form_id = ylid;
    }

    dataLayer.push(gaEvent);
  });
});

// section search
document.addEventListener("DOMContentLoaded", function () {
  const apartmentData = new Map([
    [30362, 7624],
    [30354, 7616],
    [30355, 7617],
    [30363, 7618],
    [30356, 7618],
    [30357, 7619],
    [30360, 7622],
    [30361, 7623],
    [30350, 7626],
    [30352, 7614],
    [30353, 7615],
    [30351, 7627],
    [30348, 7624],
    [30364, 7622],
    [30358, 7620],
    [30359, 7621],
    [30349, 7625],
  ]);

  window.addEventListener("message", (event) => {
    const isFormInquiry =
      event.data.type === "qupto_cloud_analytics_track" &&
      event.data.data.key === "form_inquiry_button_pressed";

    if (isFormInquiry) {
      const listing = event.data.data.contextData.apartment;

      const pivotalId = apartmentData.get(listing.id);
      const symbol = listing.display_name;

      document.body.classList.add("is-overlay");
      lenis.stop();

      if (popupProductIdsField) {
        popupProductIdsField.value = pivotalId;
      }

      if (popupProjectsIdsField) {
        popupProjectsIdsField.value = "";
      }

      if (popupMessageField) {
        popupMessageField.value = `Proszę o kontakt w sprawie apartamentu nr ${symbol}`;

        popupMessageField.closest("label").classList.add("is-active");
      }
    }
  });
});

// section interior
document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelector(".section-interior .swiper");

  if (slider) {
    new Swiper(slider, {
      modules: [Navigation],
      slidesPerView: 1,
      navigation: {
        nextEl: ".section-interior .swiper-buttons-next",
        prevEl: ".section-interior .swiper-buttons-prev",
      },
      simulateTouch: false,
      breakpoints: {
        992: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1280: {
          slidesPerView: 3,
          spaceBetween: 39,
        },
      },
    });
  }

  document
    .querySelectorAll(".section-interior .swiper-slide__wrapper")
    .forEach((gallery) => {
      const items = JSON.parse(gallery.dataset.items);

      const galleriesLightbox = new PhotoSwipeLightbox({
        dataSource: items,
        bgOpacity: 1,
        imageClickAction: "close",
        closeTitle: "Zamknij",
        showHideAnimationType: "fade",
        padding: { top: 80, bottom: 80, left: 20, right: 20 },
        pswpModule: PhotoSwipe,
      });

      galleriesLightbox.init();

      gallery.addEventListener("click", (event) => {
        event.preventDefault();

        galleriesLightbox.loadAndOpen(0);
      });
    });
});
